module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1503-09227440c86a1a47d6dc0bf72fea97cd.png";